import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What I learned at MicroConf Growth 2018",
  "description": "",
  "published": "2018-05-10T00:00:00.000Z",
  "redirect_from": ["/blog/learned-microconf-growth-2018/swizec/8364"],
  "categories": "Learning, Opinions, Personal, Side Projects, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`MicroConf was life changing. A room full of people who Get It™. A room where you can say, `}<em parentName="p">{`"Holy shit, I made so much money last month,”`}</em>{` and people say `}<em parentName="p">{`"Omg, you must be scared shitless that it's a fluke"`}</em>{` instead of, `}<em parentName="p">{`"So, going to Bali or Hawaii?`}</em></p>
    <p>{`It's refreshing to talk to Your People in person for once. So much so that I missed my flight home.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Yep, missed it. ✈️ `}<a parentName="p" {...{
          "href": "https://t.co/aoDBMsKLEv"
        }}>{`https://t.co/aoDBMsKLEv`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991666860276903937"
      }}>{`May 2, 2018`}</a></blockquote>
    <p>{`You'd think living in San Francisco would make it easy to find a crowd of entrepreneurs to talk to, but no. You have to fly to Vegas and visit MicroConf.`}</p>
    <p>{`In San Francisco, there's a lot of posturing. Everyone's always crushing it. Everyone's killing it. That's how you get VC money. Nobody's gonna invest if you say, `}<em parentName="p">{`"Look dude, we're making sales, but we don't really know why.”`}</em></p>
    <p>{`At MicroConf, it's different. People are bootstrapped. They grow their business on profits. They start from savings or with a sidehustle. They know how it is.`}</p>
    <p>{`Million dollar businesses chatting to thousand dollar businesses as equals; sharing numbers. Quite refreshing.`}</p>
    <p>{`It's been a week. Here's the good shit that stayed 👇🏻`}</p>
    <h2 {...{
      "id": "you-can-make-a-million-dollars-with-info-products"
    }}>{`You can make a million dollars with info products`}</h2>
    <p>{`This was a lesson from the hallway track. I met a guy who made $1,000,000 in revenue last year from a single info product selling at a single price for one-off purchases.`}</p>
    <p>{`Amazing. Inspiring. Took him 5 years of being full time. He didn't say how long he worked on it before going full time.`}</p>
    <p>{`Nowadays, he has 3 full-time employees, a smattering of freelancers, and worries that he might have to look into a multi-tier pricing structure to sustain growth.`}</p>
    <p>{`I'd mention his name, but MicroConf is covered by a FrieNDA, and I don't know if he wants numbers published like this.`}</p>
    <h2 {...{
      "id": "you-can-have-sustainable-growth-with-unsustainable-tactics"
    }}>{`You can have sustainable growth with unsustainable tactics`}</h2>
    <p>{`This one is from a talk by `}<a parentName="p" {...{
        "href": "https://teachable.com/"
      }}>{`Teachable`}</a>{` founder `}<a parentName="p" {...{
        "href": "https://twitter.com/ankurnagpal?lang=en"
      }}>{`Ankur Nagpal`}</a>{`. They used a curious growth engine to go from $0 to $10,000,000 ARR (annual recurring revenue) in four years.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`This is gonna be fun. $0 to $10 million ARR story `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/MicroConf?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#MicroConf`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/aylES8614L"
        }}>{`pic.twitter.com/aylES8614L`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991417124689035265"
      }}>{`May 1, 2018`}</a></blockquote>
    <p>{`Here's how you do it:`}</p>
    <ol>
      <li parentName="ol">{`You set a growth target, say 30% month over month`}</li>
      <li parentName="ol">{`You look at where you're at, say $2000`}</li>
      <li parentName="ol">{`Ok you have to find $600 of revenue this month`}</li>
      <li parentName="ol">{`Brainstorm some tactics`}</li>
      <li parentName="ol">{`Do them until you have $2600 that month`}</li>
      <li parentName="ol">{`The tactic that worked is now your normal process`}</li>
      <li parentName="ol">{`Repeat next month`}</li>
    </ol>
    <p>{`Teachable started with cold email sales as a tactic, used regular webinars for a while, and landed on the idea of online summits. Each tactic worked for a long while, became better as they standardized it, and eventually stopped producing returns.`}</p>
    <p>{`This approach stopped working when they reached $500,000 MRR (monthly recurring revenue). They then had to use more traditional approaches like ads and stuff.`}</p>
    <p>{`What I like about this is that it sort of validates what I'm already doing: Setting a target then figuring out how to get there. But it's a system. You can grow and optimize a system.`}</p>
    <h2 {...{
      "id": "ads--free-content--nurturing--win"
    }}>{`Ads + free content + nurturing == win`}</h2>
    <p>{`A short talk from the founder of `}<a parentName="p" {...{
        "href": "https://jordangal.lpages.co/jordangal-com/"
      }}>{`Jordan Gal`}</a>{` who was able to leverage $4000 in ads into $140,000 in ARR with this one weird trick.`}</p>
    <p>{`You write a bunch of free stuff like blog posts.`}</p>
    <p>{`You tie them together into a story. They used 6 over 6 weeks for the initial experiment.`}</p>
    <p>{`You promote the shit out of them on social media with paid ads and otherwise.`}</p>
    <p>{`You tag everyone with a retargeting pixel.`}</p>
    <p>{`You now have an audience who has heard about you, trusts your brand, and is interested in what you have to say.`}</p>
    <p>{`So you sell them your thing and they buy it.`}</p>
    <p>{`Fun fact: This is how I sell my `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`React + D3v4`}</a>{` book. Although I need to tidy up some of those funnels because they stopped working.`}</p>
    <h2 {...{
      "id": "dont-be-a-corporation"
    }}>{`Don't be a corporation`}</h2>
    <p>{`Be funny.`}</p>
    <p>{`Use emojis. Use gifs. Use bad grammar.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Learning about how to be funny in copywriting. World, watch out! `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/MicroConf?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#MicroConf`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/hOSYhrvRIe"
        }}>{`pic.twitter.com/hOSYhrvRIe`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991365227978485760"
      }}>{`May 1, 2018`}</a></blockquote>
    <p>{`Delight your users. Delight your readers.`}</p>
    <p>{`Do whatever it takes. Just don't make me feel like I'm talking to a Vogon. When you make reading your emails feel like work, people won't.`}</p>
    <p>{`Work is for suckers. Your users aren't suckers.`}</p>
    <p>{`Slack is a billion dollar company because their chatrooms are delightful to use. Let that sink in.`}</p>
    <h2 {...{
      "id": "just-because-its-not-a-subscription-doesnt-mean-it-wont-grow"
    }}>{`Just because it's not a subscription doesn't mean it won't grow`}</h2>
    <p>{`The craziest product: Board Gaming Tables.`}</p>
    <p>{`The quintessential one-off sale product. How many board gaming tables does a normal person need? Zero. How many does someone with hundreds of board games need? One. Maybe.`}</p>
    <p>{`And yet the folks from `}<a parentName="p" {...{
        "href": "http://boardgametables.com"
      }}>{`Board Game Tables`}</a>{` are making a killing selling these physical products for a super niche audience.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`"That kickstarter made 2.6 million dollars and I don't know about you but that's a lot of money where I'm from"`}<br parentName="p"></br><br parentName="p"></br>{`Now I want a Board Game Table`}<a parentName="p" {...{
          "href": "https://t.co/9ghSZVfmCJ"
        }}>{`https://t.co/9ghSZVfmCJ`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991387487040749568"
      }}>{`May 1, 2018`}</a></blockquote>
    <p>{`Also, that's one of the best product teaser videos I've ever seen. Makes me want a board gaming table even though I have 3 board games, no room, and no time to play.`}</p>
    <p>{`The gist of their philosophy is that, look, MRR might be king, but if you set up your SEO and your ads and your brand and word-of-mouth, and they all work, you are going to grow. You can build those channels, you can optimize them, and you can know how many sales you're making next month.`}</p>
    <p>{`Because if 5,000 people come to your site every month and you convert at 4%, that's 200 sales per month like clockwork. No recurring revenue required.`}</p>
    <p>{`Just look at this video!`}</p>
    <p>{`[`}{`embed]`}<a parentName="p" {...{
        "href": "https://www.boardgametables.com/videos/1080l.mp4"
      }}>{`https://www.boardgametables.com/videos/1080l.mp4`}</a></p>
    <h2 {...{
      "id": "your-product-exists-to-do-a-job"
    }}>{`Your product exists to do a job`}</h2>
    <p>{`People buy your product because they want to improve their life. That is all. Keep it in mind always.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`People buy your product because they want to improve their life, not because they care about you. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/MicroConf?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#MicroConf`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/lAGXexSlEb"
        }}>{`pic.twitter.com/lAGXexSlEb`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991454532411408384"
      }}>{`May 1, 2018`}</a></blockquote>
    <hr></hr>
    <p>{`You can read a full recap of `}<a parentName="p" {...{
        "href": "https://microconf.gen.co/"
      }}>{`all the MicroConf talks here`}</a></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I already miss `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/MicroConf?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#MicroConf`}</a>{` it was a blast. Would prob get a lot out of the Starter edition too. Growth went over my head a lot, but there’s only so much PTO I can afford. `}<br parentName="p"></br><br parentName="p"></br>{`Such is the `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/sidehustle?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#sidehustle`}</a>{` lyfe `}<a parentName="p" {...{
          "href": "https://t.co/KHJYbZxL7O"
        }}>{`pic.twitter.com/KHJYbZxL7O`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/991785129587630080"
      }}>{`May 2, 2018`}</a></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      